import { render, staticRenderFns } from "./PritickePack01.vue?vue&type=template&id=42644ad2&scoped=true&"
import script from "./PritickePack01.vue?vue&type=script&lang=js&"
export * from "./PritickePack01.vue?vue&type=script&lang=js&"
import style0 from "./PritickePack01.vue?vue&type=style&index=0&id=42644ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42644ad2",
  null
  
)

export default component.exports